import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 1442 1291" {...props}>
      <title>{"Main Couper"}</title>
      <g fill="none" fillRule="evenodd">
        <path
          d="M1245.171 0L1439 156.795v912.014L866.905 1265.47c-148.822 51.16-313.259 22.94-436.447-74.635l-3.72-2.978L0 912.617V42.616L123.971 0h1121.2z"
          fill="#E9F9F8"
        />
        <path
          d="M1198.06 107.52a176.23 176.23 0 01152.18 77.54L1442 320.995v328.176l-334.124 11.553a176.217 176.217 0 01-151.152-76.035l-1.027-1.505L720.863 235.29c-31.913-47.274.707-111.296 57.712-113.267z"
          fill="#FCBD39"
        />
        <path
          d="M1440 0v461.01L703.618 630.62c-121.508 27.988-248.744-7.868-337.734-94.958l-2.685-2.655L0 170.181V0h1440z"
          fill="#08AEEA"
        />
        <path
          d="M904.345-.001c34.016 34.071 45.724 88.996 18.206 136.616L596.285 701.258c-47.22 81.722-133.134 133.343-227.457 136.67L0 850.94V0z"
          fill="#1FDDB3"
          style={{
            mixBlendMode: "multiply"
          }}
        />
      </g>
    </svg>
  )
}

export const HeaderCouperDesktop = React.memo(SvgComponent)

HeaderCouperDesktop.displayName = "HeaderCouperDesktop"
